import React from 'react';
import { Redirect } from 'react-router-dom';
import { logout } from '../logic/auth';
export var Logout = function () {
    logout();
    return React.createElement(Redirect, { to: '/login' });
};
//# sourceMappingURL=Logout.js.map